import { service } from '../../../helpers/http'

export const ActionAlgorithmRunsIndex = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'indexRuns',
    payload,
  })
}

export const ActionAlgorithmRunsShow = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'showRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsEvents = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'eventsRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createTimetableRun',
    payload,
  })
}

export const ActionAlgorithmRunsTimetableGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listTimetableRunGroups',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableSummary = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'summaryTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createTeacherAttributionRun',
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionApply = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'applyTeacherAttributionRun',
    params: { id: payload.id },
    payload: payload.grid_ids ? { grid_ids: payload.grid_ids } : {},
  })
}

export const ActionAlgorithmRunsTeacherAttributionSummary = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'summaryTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listTeacherAttributionRunGroups',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionItems = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'itemsTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionTeachersBoard = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'teachersBoardTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createAmbienceAllocationRun',
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsAmbienceAllocationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedAmbienceAllocationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationSummary = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'summaryAmbienceAllocationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listAmbienceAllocationRunGroups',
    idAndPayload: true,
    payload,
  })
}
